














































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { updateAnomalyStock, destroyAnomalyStock } from '@/api/assgin';
import * as _ from 'lodash';

@Component({
  name: 'AnomalStockDialog',
})
export default class extends Vue {
  @Prop({ required: true }) private date!: string;

  @Prop({ required: true }) private locationCode!: string;

  private dialog = false;

  private id = '';

  private itemCode = '';

  private itemNumber = '';

  private itemName = '';

  private expectedQty = '';

  private actualQty = '';

  private type = '库存不足';

  private comment = '';

  private types: string[] = ['库存不足'];

  private valid = false;

  private actualQtyRules = [(v: any) => !!v || 'Actual QTY is required'];

  private typeRules = [(v: any) => !!v || 'Type is required'];

  private commentRules = [];

  @Watch('dialog')
  onChangeValue(newVal: boolean) {
    if (newVal === false) {
      this.resetForm();
    }
  }

  private async save() {
    (this.$refs.form as Vue & { validate(): () => void }).validate();
    if (this.valid) {
      this.$confirm(`Are you sure actual qty is ${this.actualQty}?`).then((result) => {
        if (result) {
          this.updateAnomalyStock();
        }
      });
    }
  }

  private async destroy() {
    this.$confirm('Are you sure remove?').then((result) => {
      if (result) {
        this.destroyAnomalyStock();
      }
    });
  }

  private async updateAnomalyStock() {
    this.$overlay(true);
    const { data } = await updateAnomalyStock(
      this.date,
      this.locationCode,
      this.itemNumber,
      this.actualQty,
      this.type,
      this.comment,
    );
    this.$overlay(false);
    this.$emit('save', {
      item_number: this.itemNumber,
      anomaly: data,
    });
    this.dialog = false;
  }

  private async destroyAnomalyStock() {
    this.$overlay(true);
    await destroyAnomalyStock(this.id);
    this.$overlay(false);
    this.$emit('destroy', {
      item_number: this.itemNumber,
    });
    this.dialog = false;
  }

  private resetValidation() {
    if (this.$refs.form) {
      (this.$refs.form as Vue & { resetValidation(): () => void }).resetValidation();
    }
  }

  private resetForm() {
    this.itemNumber = '';
    this.itemCode = '';
    this.itemName = '';
    this.expectedQty = '';
    this.type = '库存不足';
    this.comment = '';
    this.id = '';
  }

  public open(item: any) {
    this.itemNumber = item.item_number;
    this.itemCode = item.item_code;
    this.itemName = item.item_name;
    this.expectedQty = item.expected_qty;
    if (item.anomaly) {
      this.actualQty = item.anomaly.actual_quantity;
      if (this.types.find((val) => val === item.anomaly.type) === undefined) {
        this.types.push(item.anomaly.type);
      }
      this.type = item.anomaly.type;
      this.comment = item.anomaly.comment;
      this.id = item.anomaly.id;
    }
    this.dialog = true;
    this.resetValidation();
  }
}
